import useMutationApi from 'src/api/useMutationApi';

// these really are invoice types
const useTriggerFamousSalesOrderFetch = (onSuccess?: () => void) => {
  return useMutationApi<{ famousSalesOrderId: string }>({
    endpoint: 'famous/sales-orders/fetch',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useTriggerFamousSalesOrderFetch;
